import dimbox from 'dimbox';
import { debounce } from '../functions.js';
import { createApp } from 'vue/dist/vue.esm-bundler.js';
import wishlistApp from '../vue/favouritesList.js';

document.addEventListener('DOMContentLoaded', () => {
    const $triggers = document.querySelectorAll('a[data-dimbox]');

    dimbox.setConfig({
        showDownloadButton: false,
        showFullscreenButton: false,
        iframeTemplate: '<div class="dimbox-iframe-container"><iframe src="{{src}}" class="dimbox-iframe" allow="autoplay; encrypted-media" allowfullscreen></iframe><div class="dimbox-caption">{{caption}}</div></div>',
        selector: 'a.dimbox-trigger, a.wishlist-trigger',
        onAfterOpen: () => {
            let wishlistContainer = document.querySelector('.dimbox-inline-content .wishlist-list');
            if (wishlistContainer) {
                createApp(wishlistApp).mount(wishlistContainer);
            }
        }
    });

    const initDimbox = () => {
        const isTouch = window.matchMedia('(max-width: 1023px)').matches;

        $triggers.forEach($trigger => {
            $trigger.classList.remove('dimbox-trigger');

            if ($trigger.closest('.is-always-visible') ||
                (isTouch && $trigger.closest('.is-hidden-desktop')) ||
                (!isTouch && $trigger.closest('.is-hidden-touch'))) {
                $trigger.classList.add('dimbox-trigger');
            }
        });

        dimbox.init();
    };

    const debouncedInitDimbox = debounce(initDimbox);

    initDimbox();
    window.addEventListener('resize', debouncedInitDimbox);
});
